// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

@media only screen and (max-width: 767px) {
  ::ng-deep.controller-wrapper--profile .wrapper-content,
  ::ng-deep.controller-wrapper--profile .ibox-content {
    padding-inline: 0;
  }
}

.collab-body .collab-data {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
  padding-top: 80px;
  padding-inline: 0;
}
@media only screen and (max-width: 767px) {
  .collab-body .collab-data {
    padding-top: 0 !important;
    padding-inline: 0;
  }
}
.collab-body .collab-data .collab-details {
  padding: 34px 32px;
  width: 33.3333333333%;
}
@media (max-width: 1200px) {
  .collab-body .collab-data .collab-details {
    padding: 30px;
  }
}
@media only screen and (max-width: 991px) {
  .collab-body .collab-data .collab-details {
    width: 100%;
    padding: 30px;
  }
  .collab-body .collab-data .collab-details + div {
    margin-top: 17px;
  }
}
@media only screen and (max-width: 767px) {
  .collab-body .collab-data .collab-details {
    padding: 20px;
  }
}
.collab-body .collab-data .collab-details__top {
  display: flex;
  flex-wrap: wrap;
  --size: 70px;
}
.collab-body .collab-data .collab-details__top:not(:last-child) {
  margin-bottom: 20px;
}
@media only screen and (max-width: 1199px) {
  .collab-body .collab-data .collab-details__top {
    --size: 50px;
  }
}
.collab-body .collab-data .collab-details__top span,
.collab-body .collab-data .collab-details__top h2 {
  margin-top: 0;
}
.collab-body .collab-data .collab-details__top span:last-child,
.collab-body .collab-data .collab-details__top h2:last-child {
  margin-bottom: 0;
}
.collab-body .collab-data .collab-details__top span {
  font-size: 10px;
  list-height: 1.4;
  color: #676a6c;
  font-weight: 700;
  display: block;
}
.collab-body .collab-data .collab-details__top span:not(:last-child) {
  margin-bottom: 5px;
}
.collab-body .collab-data .collab-details__top h2 {
  font-family: "Museo-regular";
  font-size: clamp(18px, 1.95vw, 34px);
}
@media (max-width: 991px) {
  .collab-body .collab-data .collab-details__top h2 {
    font-size: 24px;
  }
}
.collab-body .collab-data .collab-details__top--dark span,
.collab-body .collab-data .collab-details__top--dark h2 {
  color: #fff;
  font-weight: 700;
}
.collab-body .collab-data .collab-details__topleft {
  width: calc(100% - var(--size));
  padding-right: 10px;
}
.collab-body .collab-data .collab-details__topright {
  width: var(--size);
}
.collab-body .collab-data .collab-details__toprighticon {
  width: 100%;
  height: var(--size);
  padding: 10px;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}
.collab-body .collab-data .collab-details__toprighticon--rounded {
  border-radius: 50%;
}
.collab-body .collab-data .collab-details__toprighticon--rounded > * {
  transform: scale(1.3);
}
@media only screen and (max-width: 1199px) {
  .collab-body .collab-data .collab-details__toprighticon--rounded > * {
    transform: none;
  }
}
.collab-body .collab-data .collab-details__topright span {
  transform: scale(1.5);
  display: inline-block;
}
.collab-body .collab-data .collab-details__desc {
  min-height: 160px;
}
.collab-body .collab-data .collab-details__desc *:last-child {
  margin-bottom: 0;
}
.collab-body .collab-data .collab-details__desc p {
  font-size: 14px;
  line-height: 1.5;
  font-family: "Museo-regular";
}
.collab-body .collab-data .collab-details__desc a {
  text-decoration: underline;
}
.collab-body .collab-data .collab-details__desc--dark p,
.collab-body .collab-data .collab-details__desc--dark a {
  color: #fff;
}
.collab-body .collab-data .collab-details__desc--dark a:hover {
  color: rgb(105, 190, 40);
}
.collab-body .collab-data .collab-details__social {
  padding: 10px 0 0;
  list-style: none;
  margin: 0;
  display: flex;
}
.collab-body .collab-data .collab-details__social li {
  margin-right: 20px;
  margin-bottom: 10px;
  position: relative;
}
.collab-body .collab-data .collab-details__social li .tooltip-cpy::after {
  content: "Link Copied!";
  font-size: 9px;
  margin-left: 7px;
  color: #fff;
  background-color: #73BF38;
  padding: 3px 2px;
  border-radius: 2px;
  position: absolute;
  z-index: 999;
  left: 100%;
  white-space: nowrap;
}
.collab-body .collab-data .collab-details__social img {
  max-width: 26px;
  max-height: 26px;
  width: 100%;
}
.collab-body .collab-data .collab-details.bg-grey {
  background-color: #F1F1F2;
}
.collab-body .collab-data .collab-details .my-pf {
  font-size: 10px;
  line-height: 14px;
  color: #676a6c;
  font-weight: 700;
}
.collab-body .collab-data .collab-details .social-icon {
  padding: 10px 0 0;
  list-style: none;
  margin: 0;
}
.collab-body .collab-data .collab-details .social-icon li {
  margin-left: 10px;
  margin-bottom: 10px;
}
.collab-body .collab-data .collab-details .social-icon li a img {
  max-width: 26px;
  max-height: 26px;
  width: 100%;
  margin-right: 10px;
}
.collab-body .collab-data .collab-details .social-icon li a svg {
  vertical-align: middle;
}
.collab-body .collab-data .collab-details.icon-bg {
  background-image: url("https://assets.foursightonline.com/app/images/foursight-profile-types.svg");
}
.collab-body .collab-data .collab-details.dark-bg {
  background-color: #6D6E71;
  position: relative;
  visibility: hidden;
}
@media only screen and (max-width: 991px) {
  .collab-body .collab-data .collab-details.dark-bg {
    min-height: 290px;
    margin-top: 0 !important;
  }
}
.collab-body .collab-data .collab-details.dark-bg::before {
  content: "";
  position: absolute;
  height: 0;
  width: 0;
  left: -19px;
  top: 80px;
  width: 20px;
  height: 40px;
  background-color: #6d6e71;
  clip-path: polygon(0 50%, 100% 0, 100% 100%, 0 50%);
}
@media only screen and (max-width: 991px) {
  .collab-body .collab-data .collab-details.dark-bg::before {
    width: 31px;
    height: 15px;
    top: auto;
    bottom: calc(100% - 1px);
    left: 50%;
    transform: translateX(-50%);
    clip-path: polygon(50% 0, 100% 100%, 0 100%);
  }
}
.collab-body .collab-data .collab-details.dark-bg.visible {
  visibility: visible;
}
.collab-body .collab-data .collab-details.dark-bg .collab-benifits .collab-row ::ng-deep .collab-col {
  width: 100%;
}
.collab-body .collab-data .collab-details.dark-bg .collab-benifits .collab-row ::ng-deep .collab-col h2 {
  color: #fff;
  font-size: 10px;
  line-height: 14px;
  margin-bottom: 14px;
  font-weight: 700;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
}
.collab-body .collab-data .collab-details.dark-bg .collab-benifits .collab-row ::ng-deep .collab-col select {
  margin: 14px 0;
  width: 289px;
  min-height: 41px;
  appearance: none;
  background-repeat: no-repeat;
  background-position: 96% 50%;
  background-image: url(https://assets.foursightonline.com/admin-uploads/docs/267/original.png?1657190712);
  background-size: 7%;
  padding: 0 10px;
}
.collab-body .collab-data .collab-details.dark-bg .collab-benifits .collab-row ::ng-deep .collab-col .collab-desc p {
  color: #fff;
  font-size: 14px;
  line-height: 18px;
  font-family: "Museo-regular";
}
.collab-body .collab-data .collab-details.dark-bg .collab-benifits .collab-row ::ng-deep .collab-col--pfwicn h2 {
  font-size: 28px;
  font-family: "Museo-700";
  color: #676a6c;
  margin: 0;
  color: #fff;
  line-height: 1;
}
@media only screen and (max-width: 767px) {
  .collab-body .collab-data .collab-details.dark-bg .collab-benifits .collab-row ::ng-deep .collab-col--pfwicn h2 {
    font-size: 22px;
  }
}
.collab-body .collab-data .collab-details.dark-bg .collab-benifits .collab-row ::ng-deep .collab-col--pfwicn div > span {
  color: #fff;
  display: block;
  margin-bottom: 13px;
}
.collab-body .collab-data .collab-details.dark-bg .collab-benifits .collab-row ::ng-deep .collab-col--pfwicn .collab-desc {
  width: 100%;
  padding: 19px 0;
}
.collab-body .collab-data .collab-details.dark-bg .collab-benifits .collab-row ::ng-deep .collab-col--pfwicn .collab-desc p {
  font-size: 14px;
  line-height: 1.3;
  font-family: "Museo-regular";
  color: #676a6c;
}
.collab-body .collab-data .collab-details.dark-bg .collab-benifits .collab-row ::ng-deep .collab-col--pfwicn .collab-desc p:last-child {
  margin-bottom: 0;
}
.collab-body .collab-data .collab-details.dark-bg .collab-benifits .collab-row ::ng-deep .collab-col--pfwicn.pf-icon {
  width: 70px;
  height: 70px;
  background-color: #fff !important;
  display: flex;
  align-items: center;
  justify-content: center;
}
.collab-body .collab-data .collab-details.dark-bg .collab-benifits .collab-row ::ng-deep .collab-col--pfwicn.pf-icon .profile_types {
  transform: scale(1.5);
}
.collab-body .collab-data .collab-details.dark-bg .collab-benifits .collab-row ::ng-deep .collab-col--pfwicn.pf-icon img {
  width: 100%;
  max-width: 52px;
}
.collab-body .collab-data .collab-details.profile-icons {
  padding: 35px 20px 35px 38px;
  position: relative;
}
@media only screen and (max-width: 991px) {
  .collab-body .collab-data .collab-details.profile-icons {
    border: 1px solid #E2E2E2;
  }
}
@media only screen and (max-width: 991px) {
  .collab-body .collab-data .collab-details.profile-icons {
    padding: 30px 24px;
  }
}
.collab-body .collab-data .collab-details.profile-icons::before {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 18px;
  border: 1px solid #E2E2E2;
  pointer-events: none;
}
@media only screen and (max-width: 991px) {
  .collab-body .collab-data .collab-details.profile-icons::before {
    display: none;
  }
}
.collab-body .collab-data .collab-details.profile-icons .collab-pf-img {
  text-align: center;
}
.collab-body .collab-data .collab-details.profile-icons .collab-pf-img p {
  font-size: 16px;
  line-height: 22px;
  font-weight: 700;
}
.collab-body .collab-data .collab-details.profile-icons .pf-heading {
  text-align: center;
  margin-bottom: 15px;
}
.collab-body .collab-data .collab-details.profile-icons .pf-heading p {
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-weight: bold;
  font-size: 16px;
  margin: 0;
}
.collab-body .collab-data .collab-details.profile-icons .pf-heading span {
  font-size: 10px;
  display: block;
  line-height: 1.5;
  margin-left: 10px;
  color: #676a6c;
  font-style: italic;
}
.collab-body .collab-data .collab-details.profile-icons .icons .icon-img {
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  margin: 0 -2px;
  padding: 0;
}
.collab-body .collab-data .collab-details.profile-icons .icons .icon-img li {
  width: 20%;
  padding: 0 2px;
  margin-top: 0px;
}
.collab-body .collab-data .collab-details.profile-icons .icons .icon-img li .icon-img__item {
  text-align: center;
  position: relative;
  padding: 20px 2px 10px;
  border: 1px solid transparent;
  cursor: pointer;
  box-shadow: 1px 2px 3px transparent;
  height: 100%;
  min-height: 80px;
  opacity: 0.5;
}
@media only screen and (max-width: 1199px) {
  .collab-body .collab-data .collab-details.profile-icons .icons .icon-img li {
    width: 33.3333333333%;
  }
}
.collab-body .collab-data .collab-details.profile-icons .icons .icon-img li span {
  display: block;
  height: 15px;
  margin-top: 7px;
}
.collab-body .collab-data .collab-details.profile-icons .icons .icon-img li.active .icon-img__item {
  opacity: 1;
  box-shadow: 1px 2px 3px #ccc;
}
.collab-body .collab-data .collab-details.profile-icons .icons .icon-img li.active--focus {
  opacity: 1 !important;
}
.collab-body .collab-data .collab-details.profile-icons .icons .icon-img li.active--focus .icon-img__item {
  opacity: 1 !important;
  box-shadow: 1px 2px 3px #ccc;
}
.collab-body .collab-data .collab-details.profile-icons .icons .icon-img li.inactive {
  opacity: 0.5;
}
.collab-body .collab-data .collab-details.profile-icons .icons .icon-img li.inactive--focus {
  opacity: 0.5;
}
.collab-body .collab-data .collab-details.profile-icons .icons .icon-img li.inactive--focus.active {
  opacity: 1;
}
.collab-body .collab-data .collab-details.profile-icons .icons .icon-img li.inactive--focus.active--focues {
  opacity: 1;
}
.collab-body .collab-data .collab-details.profile-icons .icons .icon-img li svg,
.collab-body .collab-data .collab-details.profile-icons .icons .icon-img li img {
  height: 21px;
  max-width: 44px;
  width: 100%;
}
.collab-body .collab-data .collab-details.profile-icons .icons .icon-img li span {
  font-size: 8px;
  display: block;
}
.collab-body .collab-data .collab-row {
  display: flex;
  flex-wrap: wrap;
}
.collab-body .collab-data .collab-row.flx-spcbtw {
  justify-content: space-between;
  align-items: center;
}
.collab-body .collab-data .collab-row ::ng-deep.collab-col {
  width: calc(100% - 70px);
  padding-right: 10px;
}
.collab-body .collab-data .collab-row ::ng-deep.collab-col h2 {
  font-size: clamp(18px, 2.5vw, 34px);
  font-family: "Museo-700";
  color: #676a6c;
  margin: 0;
}
@media only screen and (max-width: 767px) {
  .collab-body .collab-data .collab-row ::ng-deep.collab-col h2 {
    font-size: 24px;
  }
}
.collab-body .collab-data .collab-row ::ng-deep.collab-col .collab-desc {
  width: 100%;
  padding: 19px 0;
  min-height: 160px;
}
.collab-body .collab-data .collab-row ::ng-deep.collab-col .collab-desc p {
  font-size: 14px;
  line-height: 1.3;
  font-family: "Museo-regular";
  color: #676a6c;
}
.collab-body .collab-data .collab-row ::ng-deep.collab-col .collab-desc p:last-child {
  margin-bottom: 0;
}
.collab-body .collab-data .collab-row ::ng-deep.collab-col .collab-desc p a {
  cursor: pointer;
  text-decoration: underline;
}
.collab-body .collab-data .collab-row ::ng-deep.collab-col .collab-desc p a:not(.p_link) {
  color: #fff;
}
.collab-body .collab-data .collab-row ::ng-deep.collab-col.pf-icon {
  width: 70px;
  height: 70px;
  background-color: #fff !important;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: none;
  padding: 10px;
}
.collab-body .collab-data .collab-row ::ng-deep.collab-col.pf-icon .profile_types {
  transform: scale(1.5);
}

.tp__dd {
  position: relative;
}
.tp__dd:hover > .tp__ddbody {
  display: block;
}
.tp__ddhdr {
  display: flex;
  flex-wrap: wrap;
  cursor: pointer;
  color: #676a6c;
  padding: 12px 19px;
  background-color: #fff;
  background-image: url(https://assets.foursightonline.com/admin-uploads/docs/267/original.png?1657190712);
  background-size: 13px 8px;
  background-repeat: no-repeat;
  background-position: right 15px center;
}
.tp__ddhdrtext, .tp__ddbodytext {
  font-size: 14px;
  line-height: 19px;
}
.tp__ddhdrimage, .tp__ddbodyimage {
  width: 19px;
  margin-left: 9px;
}
.tp__ddhdrimage svg, .tp__ddbodyimage svg {
  width: 100%;
  height: auto;
}
.tp__ddbody {
  background-color: #fff;
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  z-index: 9;
  max-height: 176px;
  overflow-y: auto;
  border-top: 1px solid #6d6e71;
  display: none;
}
.tp__ddbody ul {
  padding: 0;
  margin: 0;
}
.tp__ddbody li {
  display: flex;
  flex-wrap: wrap;
  cursor: pointer;
  color: #676a6c;
  padding: 12px 19px;
}
.tp__ddbody li.active {
  background-color: #f1f1f2;
}

@media print {
  .collab-body .collab-data {
    padding-inline: 0;
    margin-inline: -15px;
  }
  .collab-body .collab-data .collab-details {
    padding: 15px;
  }
  .collab-body .collab-data .collab-details .social-icon li {
    width: 13%;
  }
  .collab-body .collab-data .collab-details .social-icon li img {
    height: 20px !important;
    width: auto !important;
  }
  .collab-body .collab-data .collab-details .social-icon li svg {
    transform: scale(0.7);
  }
  .collab-body .collab-data .collab-details.profile-icons {
    padding: 15px;
  }
  .collab-body .collab-data .collab-details.profile-icons::before {
    display: none;
  }
  .collab-body .collab-data .collab-details.profile-icons .icons .icon-img {
    margin-inline: -10px;
  }
  .collab-body .collab-data .collab-details.profile-icons .icons .icon-img li {
    min-height: initial;
  }
  .collab-body .collab-data .collab-details.profile-icons .icons .icon-img li img {
    height: auto;
  }
  .collab-body .collab-data .collab-details.bg-grey {
    background-color: #F1F1F2 !important;
  }
  .collab-body .collab-data .collab-details.dark-bg {
    background-color: #6D6E71 !important;
  }
  .collab-body .collab-data .collab-details.dark-bg .collab-col--pfwicn .pfw-icon .flx-spcbtw h2 {
    color: #fff !important;
  }
  .collab-body .collab-data .collab-details.dark-bg .collab-col--pfwicn .pfw-icon .flx-spcbtw span {
    color: #fff !important;
    margin-bottom: 0;
  }
  .collab-body .collab-data .collab-details.dark-bg .collab-desc p {
    color: #fff !important;
  }
}
.loader-container {
  position: absolute;
  left: 0;
  right: 0;
  text-align: center;
  top: 0;
  bottom: 0;
  background: rgba(236, 236, 236, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999999999;
  height: 100vh;
  margin: 0 auto;
}

.loader-spin {
  background-color: hsla(0, 0%, 92.5%, 0.9);
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
}

.loader__inner {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

#Path_129 {
  animation: blink 2s linear infinite;
  opacity: 0;
}

#Path_130 {
  animation: blink 2s linear infinite;
  animation-delay: 0.5s;
  opacity: 0;
}

#Path_132 {
  animation: blink 2s linear infinite;
  animation-delay: 1s;
  opacity: 0;
}

#Path_131 {
  animation: blink 2s linear infinite;
  animation-delay: 1.5s;
  opacity: 0;
}

@keyframes blink {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/app/components/custom-profile/custom-collaboration-profile/custom-collaboration-profile.component.scss"],"names":[],"mappings":"AAgIA;EACE,eAAA;AC/HF;;ADkIA;EACE,aAAA;EACA,eAAA;AC/HF;;ADkIA;EACE,sBAAA;AC/HF;;ADkIA;EACE,8BAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,aAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;AD6IE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;AC1IJ;AD4II;;;;;;EACE,gBAAA;ACrIN;ADyIE;;EAEE,eA5GO;EA6GP,gBA3GO;AC5BX;ADyII;EALF;;IAMI,eA/GY;ECtBhB;AACF;ADwIE;;EAEE,eAlHO;EAmHP,gBAjHO;ACrBX;ADwII;EALF;;IAMI,eArHY;ECfhB;AACF;ADuIE;;EAEE,eAxHO;EAyHP,gBAvHO;ACdX;ADuII;EALF;;IAMI,eA3HY;ECRhB;AACF;ADsIE;;EAEE,eA9HO;EA+HP,gBA7HO;ACPX;ADuIE;;EAEE,eAhIO;EAiIP,gBAhIO;ACLX;ADwIE;;EAEE,eAnIO;EAoIP,gBAnIO;ACHX;AD4IE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;AC1IJ;AD4II;EACE,gBAAA;AC1IN;AD6II;EAXF;IAYI,eAAA;EC1IJ;AACF;AD6IE;;EAEE,UAAA;EACA,SAAA;AC3IJ;AD8IE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;AC5IJ;;ADgJA;EACE,sBAxNQ;AC2EV;;ADgJA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;AC7IF;AD+IE;EALF;IAMI,cAAA;EC5IF;AACF;AD8IE;EACE,iBA1Ka;AC8BjB;AD+IE;EACE,gBApLa;EAqLb,WAAA;AC7IJ;;ADkJE;EACE,kBAAA;AC/IJ;ADkJE;EACE,iBAAA;AChJJ;;ADqJE;EACE,aAAA;AClJJ;;ADsJA;EACE,kBAAA;ACnJF;ADqJE;EACE,mBAAA;ACnJJ;ADuJI;EACE,sBAAA;ACrJN;ADyJE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ACuEnB;ADyJI;EACE,sBAAA;ACvJN;AD0JI;EAVF;IAWI,eApOoB;EC6ExB;AACF;AD0JE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ACxJJ;AD0JI;EACE,sBAAA;ACxJN;AD2JI;EACE,WAAA;ACzJN;AD4JI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ACkMZ;;AD+JA;EACE,mBA1PO;AC8FT;AD8JE;EAHF;IAII,mBAAA;EC3JF;AACF;AD6JE;EACE,mBAAA;AC3JJ;AD8JE;EACE,aArQK;ACyGT;AD8JI;EAHF;IAII,aAAA;EC3JJ;AACF;AD6JI;EACE,aAAA;AC3JN;;ADgKA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;AC7JF;AD+JE;EACE,eAAA;AC7JJ;ADgKE;EACE,sCAAA;AC9JJ;ADiKE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;AC/JJ;;AD8KE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;AC3KJ;AD6KI;EACE,kBAAA;AC3KN;AD8KI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;AC5KN;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,+BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AC9KF;ADgLE;EACE,2BAAA;EACA,mBAAA;AC9KJ;ADiLE;EACE,yBAzbiB;EA0bjB,WA1aO;AC2PX;ADkLE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;AChLJ;ADmLE;EACE,yBAjckB;EAkclB,cArciB;ACoRrB;ADoLE;EACE,yBAvbS;EAwbT,WA1bO;ACwQX;ADoLI;EACE,6BAAA;AClLN;;ADuLA;EACE;IACE,uBAAA;ECpLF;EDuLA;IACE,yBAAA;ECrLF;AACF;ADwLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,+BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,qBAAA;ACtLF;;ADyLA;EACE,UAAA;ACtLF;ADwLE;EACE,qBAAA;ACtLJ;;AD0LA;EACE,UAAA;ACvLF;;AD2LE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ACzLJ;AD4LM;EACE,mBAAA;AC1LR;AD+LE;EACE,2BAAA;AC7LJ;ADgME;EACE,uBAAA;AC9LJ;ADiME;EACE,mBAAA;AC/LJ;;ADoME;EACE,mBAAA;ACjMJ;ADoME;EACE,yBAAA;AClMJ;ADqME;EACE,sBAAA;ACnMJ;ADsME;EACE,uBAAA;ACpMJ;ADuME;EACE,oBAAA;ACrMJ;;AAvYM;EAHF;;IAII,iBAAA;EA4YN;AACF;;AAjYE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,WAAA;EACA,iBAAA;EACA,iBAAA;AAoYJ;AAlYI;EARF;IASI,yBAAA;IACA,iBAAA;EAqYJ;AACF;AAnYI;EACE,kBAAA;EACA,qBAAA;AAqYN;AAlYM;EALF;IAMI,aAAA;EAqYN;AACF;AAnYM;EATF;IAUI,WAAA;IACA,aAAA;EAsYN;EApYM;IACE,gBAAA;EAsYR;AACF;AAnYM;EAlBF;IAmBI,aAAA;EAsYN;AACF;AApYM;EACE,aAAA;EACA,eAAA;EAMA,YAAA;AAiYR;AArYQ;EACE,mBAAA;AAuYV;AAlYQ;EAVF;IAWI,YAAA;EAqYR;AACF;AAnYQ;;EAEE,aAAA;AAqYV;AAnYU;;EACE,gBAAA;AAsYZ;AAlYQ;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;AAoYV;AAlYU;EACE,kBAAA;AAoYZ;AAhYQ;EACE,4BDvFC;ECwFD,oCAAA;AAkYV;AAhYU;EAJF;IAKI,eAAA;EAmYV;AACF;AA9XU;;EAEE,WAAA;EACA,gBD1FH;AC0dT;AA5XQ;EACE,+BAAA;EACA,mBAAA;AA8XV;AA3XQ;EACE,kBAAA;AA6XV;AA3XU;EACE,WAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AA6XZ;AA3XY;EACE,kBAAA;AA6Xd;AA3Xc;EACE,qBAAA;AA6XhB;AA3XgB;EAHF;IAII,eAAA;EA8XhB;AACF;AAzXU;EACE,qBAAA;EACA,qBAAA;AA2XZ;AAtXM;EACE,iBAAA;AAwXR;AAtXQ;EACE,gBAAA;AAwXV;AArXQ;EACE,eAAA;EACA,gBAAA;EACA,4BDvJC;AC8gBX;AApXQ;EACE,0BAAA;AAsXV;AAjXU;;EAEE,WAAA;AAmXZ;AAhXU;EACE,wBDnJI;ACqgBhB;AA7WM;EACE,iBAAA;EACA,gBAAA;EACA,SAAA;EACA,aAAA;AA+WR;AA5WQ;EACE,kBAAA;EACA,mBAAA;EACA,kBAAA;AA8WV;AA5WU;EACE,uBAAA;EACA,cAAA;EACA,gBAAA;EACA,WAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;AA8WZ;AAzWQ;EACE,eAAA;EACA,gBAAA;EACA,WAAA;AA2WV;AAvWM;EACE,yBAAA;AAyWR;AAtWM;EACE,eAAA;EACA,iBAAA;EACA,cDtLa;ECuLb,gBD5MC;ACojBT;AArWM;EACE,iBAAA;EACA,gBAAA;EACA,SAAA;AAuWR;AArWQ;EACE,iBAAA;EACA,mBAAA;AAuWV;AAnWY;EAEE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;AAoWd;AAjWY;EACE,sBAAA;AAmWd;AA7VM;EACE,kGAAA;AA+VR;AA5VM;EACE,yBAAA;EACA,kBAAA;EACA,kBAAA;AA8VR;AA5VQ;EALF;IAMI,iBAAA;IACA,wBAAA;EA+VR;AACF;AA5VQ;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,yBDvOW;ECwOX,mDAAA;AA8VV;AA5VU;EAZF;IAaI,WAAA;IACA,YAAA;IACA,SAAA;IACA,wBAAA;IACA,SAAA;IACA,2BAAA;IACA,4CAAA;EA+VV;AACF;AA5VQ;EACE,mBAAA;AA8VV;AAzVY;EACE,WAAA;AA2Vd;AAzVc;EACE,WAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBD7RP;EC8RO,wED5SH;ACuoBb;AAxVc;EACE,cAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,4BAAA;EACA,4BAAA;EACA,wGAAA;EACA,mBAAA;EACA,eAAA;AA0VhB;AArVgB;EACE,WAAA;EACA,eAAA;EACA,iBAAA;EACA,4BD7TP;ACopBX;AAjVgB;EACE,eAAA;EACA,wBDpUP;ECqUO,cDvSG;ECwSH,SAAA;EACA,WAAA;EACA,cAAA;AAmVlB;AAjVkB;EARF;IASI,eAAA;EAoVlB;AACF;AAjVgB;EACE,WAAA;EACA,cAAA;EACA,mBAAA;AAmVlB;AAhVgB;EACE,WAAA;EACA,eAAA;AAkVlB;AAhVkB;EACE,eAAA;EACA,gBAAA;EACA,4BD7VT;EC8VS,cD/TC;ACipBrB;AAhVoB;EACE,gBAAA;AAkVtB;AA7UgB;EACE,WAAA;EACA,YAAA;EACA,iCAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;AA8UlB;AA5UkB;EACE,qBAAA;AA8UpB;AA3UkB;EACE,WAAA;EACA,eAAA;AA6UpB;AApUM;EACE,4BAAA;EACA,kBAAA;AAsUR;AAnUQ;EALF;IAMI,yBAAA;EAsUR;AACF;AApUQ;EATF;IAUI,kBAAA;EAuUR;AACF;AArUQ;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,yBAAA;EACA,oBAAA;AAuUV;AArUU;EAVF;IAWI,aAAA;EAwUV;AACF;AArUQ;EACE,kBAAA;AAuUV;AArUU;EACE,eAAA;EACA,iBAAA;EACA,gBDtZH;AC6tBT;AAnUQ;EAEE,kBAAA;EACA,mBAAA;AAoUV;AAlUU;EACE,wED9aC;EC+aD,iBAAA;EACA,eAAA;EACA,SAAA;AAoUZ;AAjUU;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,cDtZS;ECuZT,kBAAA;AAmUZ;AA7TU;EACE,gBAAA;EACA,aAAA;EACA,eAAA;EACA,cAAA;EACA,UAAA;AA+TZ;AA7TY;EACE,UAAA;EACA,cAAA;EACA,eAAA;AA+Td;AA7Tc;EACE,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,6BAAA;EACA,eAAA;EACA,mCAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;AA+ThB;AA5Tc;EAjBF;IAkBI,qBAAA;EA+Td;AACF;AA7Tc;EACE,cAAA;EACA,YAAA;EACA,eAAA;AA+ThB;AA1TgB;EACE,UAAA;EACA,4BAAA;AA4TlB;AAzTgB;EACE,qBAAA;AA2TlB;AAzTkB;EACE,qBAAA;EACA,4BAAA;AA2TpB;AAtTc;EACE,YAAA;AAwThB;AAtTgB;EACE,YAAA;AAwTlB;AAtTkB;EACE,UAAA;AAwTpB;AAtToB;EACE,UAAA;AAwTtB;AAlTc;;EAEE,YAAA;EACA,eAAA;EACA,WAAA;AAoThB;AAjTc;EACE,cAAA;EACA,cAAA;AAmThB;AA3SI;EACE,aAAA;EACA,eAAA;AA6SN;AA3SM;EACE,8BAAA;EACA,mBAAA;AA6SR;AA1SM;EAEE,wBAAA;EACA,mBAAA;AA2SR;AAzSQ;EACE,mCAAA;EACA,wBD/hBC;ECgiBD,cDlgBW;ECmgBX,SAAA;AA2SV;AAzSU;EANF;IAOI,eAAA;EA4SV;AACF;AAzSQ;EACE,WAAA;EACA,eAAA;EACA,iBAAA;AA2SV;AAzSU;EACE,eAAA;EACA,gBAAA;EACA,4BDjjBD;ECkjBC,cDnhBS;AC8zBrB;AAzSY;EACE,gBAAA;AA2Sd;AAxSY;EACE,eAAA;EACA,0BAAA;AA0Sd;AAxSc;EACE,WAAA;AA0ShB;AApSQ;EACE,WAAA;EACA,YAAA;EACA,iCAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,aAAA;AAsSV;AAnSU;EACE,qBAAA;AAqSZ;;AA5RE;EACE,kBAAA;AA+RJ;AA7RI;EACE,cAAA;AA+RN;AA3RE;EACE,aAAA;EACA,eAAA;EACA,eAAA;EACA,cDtkBiB;ECukBjB,kBAAA;EACA,sBAAA;EACA,wGAAA;EACA,yBAAA;EACA,4BAAA;EACA,sCAAA;AA6RJ;AA1RE;EAEE,eAAA;EACA,iBAAA;AA2RJ;AAxRE;EAEE,WAAA;EACA,gBAAA;AAyRJ;AAvRI;EACE,WAAA;EACA,YAAA;AAyRN;AArRE;EACE,sBAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,UAAA;EACA,iBAAA;EACA,gBAAA;EACA,6BAAA;EACA,aAAA;AAuRJ;AArRI;EACE,UAAA;EACA,SAAA;AAuRN;AApRI;EACE,aAAA;EACA,eAAA;EACA,eAAA;EACA,cDrnBe;ECsnBf,kBAAA;AAsRN;AApRM;EACE,yBDjnBc;ACu4BtB;;AAhRA;EAEI;IACE,iBAAA;IACA,oBAAA;EAkRJ;EAhRI;IACE,aAAA;EAkRN;EA/QQ;IACE,UAAA;EAiRV;EA/QU;IACE,uBAAA;IACA,sBAAA;EAiRZ;EA9QU;IACE,qBAAA;EAgRZ;EA3QM;IACE,aAAA;EA6QR;EA3QQ;IACE,aAAA;EA6QV;EAzQU;IACE,oBAAA;EA2QZ;EAzQY;IACE,mBAAA;EA2Qd;EAzQc;IACE,YAAA;EA2QhB;EApQM;IACE,oCAAA;EAsQR;EAnQM;IACE,oCAAA;EAqQR;EAhQc;IACE,sBAAA;EAkQhB;EA/Pc;IACE,sBAAA;IACA,gBAAA;EAiQhB;EAzPU;IACE,sBAAA;EA2PZ;AACF;AAnPA;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,oCAAA;EAGA,aAAA;EAGA,uBAAA;EAGA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;AAqPF;;AAlPA;EACE,yCAAA;EACA,eAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;AAqPF;;AAlPA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;AAqPF;;AAjPA;EACE,mCAAA;EACA,UAAA;AAoPF;;AAjPA;EACE,mCAAA;EACA,qBAAA;EACA,UAAA;AAoPF;;AAjPA;EACE,mCAAA;EACA,mBAAA;EACA,UAAA;AAoPF;;AAjPA;EACE,mCAAA;EACA,qBAAA;EACA,UAAA;AAoPF;;AAjPA;EACE;IACE,UAAA;EAoPF;EAjPA;IACE,UAAA;EAmPF;EAhPA;IACE,UAAA;EAkPF;AACF","sourcesContent":["// Font\n$font-stack: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$muso-100: \"Museo-100\";\n$muso-300: \"Museo-300\";\n$muso-300-i: \"Museo-300Italic\";\n$muso-500: \"Museo-regular\";\n$muso-700: \"Museo-700\";\n$muso-700-i: \"Museo-700Italic\";\n$muso-sans: \"MuseoSans-300\";\n$car-font: \"Marydale\";\n$car-big-font: \"Bangers\", cursive;\n$font-museo: \"Conv_museo-500-webfont\";\n$font-helvetica: \"Helvetica\", \"open sans\";\n$MuseoSansCondensed-300: \"MuseoSansCondensed-300\";\n\n$fwBold: 700;\n\n//Foursight\n// $clarify-color: #06A6CE;\n// $ideate-color: #FF8300;\n// $develop-color: #7BBC43;\n// $implement-color: #FF485C;\n$clarify-color: rgba(0, 173, 208, 1);\n$ideate-color: rgba(255, 121, 0, 1);\n$develop-color: rgba(105, 190, 40, 1);\n$implement-color: rgba(245, 67, 89, 1);\n$low-clarify-color: rgba(0, 173, 208, 1);\n$low-ideate-color: rgba(255, 121, 0, 1);\n$low-develop-color: rgba(105, 190, 40, 1);\n$low-implement-color: rgba(245, 67, 89, 1);\n$profile-connector-color: #656668;\n// Profile Neutral color\n$integrator-color: #e3e3e3;\n// Team Report\n$report-integrator: #a7a7a7;\n// Body text color in reports\n$body-content-color: #676a6c;\n// Learner Map\n$gray-lm: rgba(0, 0, 0, 0.2);\n$border-color: #aaa;\n\n$color-neutral-dark: #6d6e71;\n$color-neutral-dark-500: #6a6a6a;\n$color-neutral-mid: #ccc;\n$color-neutral-light: #f1f1f2;\n$color-neutral-mid-old: #9e9e97;\n$color-dark-green: #4cae4c;\n$color-light-grey: #d9d9d9;\n$color-red: #ff485c;\n\n$color-grey-1: #e7eaec;\n\n$clrGray1: #f6f6f6;\n\n$clrDarkGray1: #ddd;\n\n$clrGrey: #eee;\n$clrWhite: #fff;\n$clrBlack: #000;\n$clrWarning: #f8ac59;\n\n$assets: \"https://assets.foursightonline.com/app\";\n$adminUpload: \"https://assets.foursightonline.com/admin-uploads/docs/\";\n\n$separator: \"\\//\";\n\n$active-class: #017ebc;\n\n// anchor Tag\n$anchor-color: #337ab7;\n\n//Sidebar\n$color-light-type: #fff;\n// submenu background\n$fs-dark-grey: #464646;\n// Hover\n$fs-active-light: #5f5f63;\n$fs-sidenav-bg: #333333;\n$fs-sidenav-hov-bg: #3e3e3f;\n$fs-green: #69be28;\n\n$clrInputAccent: #639935;\n\n$fn-fs-h1: 44px;\n$fn-fs-h1-mobile: 38px;\n$fn-lh-h1: 1.1;\n\n$fn-fs-h2: 38px;\n$fn-fs-h2-mobile: 32px;\n$fn-lh-h2: 1.2;\n\n$fn-fs-h3: 32px;\n$fn-fs-h3-mobile: 24px;\n$fn-lh-h3: 1.2;\n\n$fn-fs-h4: 24px;\n$fn-fs-h4-mobile: 20px;\n$fn-lh-h4: 1.2;\n\n$fn-fs-h5: 18px;\n$fn-lh-h5: 1.2;\n\n$fn-fs-h6: 16px;\n$fn-lh-h6: 1.3;\n\n$fn-title-subtext: 22px;\n$fn-title-subtext-mobile: 18px;\n\n$pageWidth: 1080px;\n$pageWidthSmall: 820px;\n$pageWidthFluid: 1200px;\n\n$secPad: 60px;\n\n$pageWidth: 1080px;\n$pageWidthFluid: 1200px;\n\n$desktop: \"only screen and (max-width: 1600px)\";\n$mac: \"only screen and (max-width: 1350px)\";\n$pc-up: \"only screen and (min-width: 1200px)\";\n$pc: \"only screen and (max-width: 1199px)\";\n$tablet-up: \"only screen and (min-width: 992px)\";\n$tablet: \"only screen and (max-width: 991px)\";\n$mobile-up: \"only screen and (min-width: 768px)\";\n$mobile: \"only screen and (max-width: 767px)\";\n$xl: \"only screen and (max-width: 1440px)\";\n$xl-up: \"only screen and (min-width: 1440px)\";\n\nimg {\n  max-width: 100%;\n}\n\n.flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dir-col {\n  flex-direction: column;\n}\n\n.dir-col-rev {\n  flex-direction: column-reverse;\n}\n\n.mh-full {\n  min-height: 100%;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.bt-0 {\n  border-top: 0;\n}\n\n.bb-0 {\n  border-bottom: 0;\n}\n\n@mixin headingfont() {\n  font-family: $muso-700 !important;\n  font-weight: normal !important;\n}\n\n@mixin contentfont() {\n  font-family: $muso-300 !important;\n  font-weight: normal !important;\n}\n\n.fn-body {\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    --hGap: 10px;\n    font-family: $muso-700;\n    color: $color-neutral-dark;\n    margin-bottom: var(--hGap);\n    margin-top: 0;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  h1,\n  .h1-text {\n    font-size: $fn-fs-h1;\n    line-height: $fn-lh-h1;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h1-mobile;\n    }\n  }\n\n  h2,\n  .h2-text {\n    font-size: $fn-fs-h2;\n    line-height: $fn-lh-h2;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h2-mobile;\n    }\n  }\n\n  h3,\n  .h3-text {\n    font-size: $fn-fs-h3;\n    line-height: $fn-lh-h3;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h3-mobile;\n    }\n  }\n\n  h4,\n  .h4-text {\n    font-size: $fn-fs-h4;\n    line-height: $fn-lh-h4;\n  }\n\n  h5,\n  .h5-text {\n    font-size: $fn-fs-h5;\n    line-height: $fn-lh-h5;\n  }\n\n  h6,\n  .h6-text {\n    font-size: $fn-fs-h6;\n    line-height: $fn-lh-h6;\n  }\n\n  $fn-title-subtext: 22px;\n  $fn-title-subtext-mobile: 18px;\n\n  p {\n    font-size: 18px;\n    line-height: 1.6;\n    color: $color-neutral-dark-500;\n    margin-top: 0;\n    margin-bottom: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media #{$mobile} {\n      font-size: 16px;\n    }\n  }\n\n  ul,\n  ol {\n    padding: 0;\n    margin: 0;\n  }\n\n  sup {\n    font-size: 0.7em;\n    position: relative;\n    top: 5px;\n    display: inline-block;\n    vertical-align: top;\n  }\n}\n\n.bg-grey {\n  background-color: $clrGrey;\n}\n\n.fn-container {\n  max-width: $pageWidth;\n  width: calc(100% - 30px);\n  margin-inline: auto;\n\n  @media #{$tablet-up} {\n    margin-left: 0;\n  }\n\n  &--fluid {\n    max-width: $pageWidthFluid;\n  }\n\n  &--small {\n    max-width: $pageWidthSmall;\n    width: 100%;\n  }\n}\n\n.text {\n  &-center {\n    text-align: center;\n  }\n\n  &-right {\n    text-align: right;\n  }\n}\n\n.d {\n  &-none {\n    display: none;\n  }\n}\n\n.section-title {\n  text-align: center;\n\n  &:not(:last-child) {\n    margin-bottom: calc($secPad - 20px);\n  }\n\n  h2 {\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n  }\n\n  p {\n    max-width: 900px;\n    width: 100%;\n    margin-inline: auto;\n    font-size: $fn-title-subtext;\n\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n\n    @media #{$mobile} {\n      font-size: $fn-title-subtext-mobile;\n    }\n  }\n\n  .section-title__linkcontainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n\n    &:not(:last-child) {\n      margin-block-end: 20px;\n    }\n\n    & > * {\n      margin: 5px;\n    }\n\n    .fn-btn {\n      padding-block: 6px;\n      padding-inline: 13px;\n      font-size: 12px;\n      font-family: $muso-sans;\n    }\n  }\n}\n\n.section-padding {\n  padding-block: $secPad;\n\n  @media #{$mobile} {\n    padding-block: ($secPad - 20px);\n  }\n\n  &-small {\n    padding-block: calc($secPad / 2);\n  }\n\n  &-all {\n    padding: $secPad;\n\n    @media #{$mobile} {\n      padding: calc($secPad / 2);\n    }\n\n    &-small {\n      padding: calc($secPad / 2);\n    }\n  }\n}\n\n.headline {\n  --lineSize: 10px;\n  width: fit-content;\n  padding-block-end: calc(10px + var(--lineSize));\n  margin-inline: auto;\n  position: relative;\n\n  &--small-border {\n    --lineSize: 6px;\n  }\n\n  &:not(:last-child) {\n    margin-bottom: calc(var(--hGap) * 2.5);\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: var(--lineSize);\n    background: linear-gradient(\n      90deg,\n      $clarify-color 0%,\n      $clarify-color 25%,\n      $ideate-color 25%,\n      $ideate-color 50%,\n      $develop-color 50%,\n      $develop-color 75%,\n      $implement-color 75%,\n      $implement-color 100%\n    );\n  }\n}\n\n.custom-list {\n  li {\n    font-size: 18px;\n    line-height: 1.4;\n    color: $color-neutral-dark-500;\n    list-style: none;\n    position: relative;\n    padding-left: 15px;\n\n    &:not(:last-child) {\n      margin-bottom: 4px;\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 10px;\n      left: 0;\n      width: 3px;\n      height: 3px;\n      background-color: var(--clrProfile);\n    }\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.fn-btn {\n  padding-block: 20px;\n  padding-inline: 28px;\n  background-color: $develop-color;\n  color: $clrWhite;\n  font-size: 18px;\n  line-height: 1.2;\n  display: inline-block;\n  font-family: $muso-700;\n  text-decoration: none;\n  word-break: break-all;\n  text-align: center;\n  transition: background-color 0.3s;\n\n  &:focus {\n    outline: 1px dashed $color-neutral-dark-500;\n    outline-offset: 4px;\n  }\n\n  &:hover {\n    background-color: $color-neutral-dark;\n    color: $clrWhite;\n  }\n\n  &--sm {\n    font-size: 14px;\n    padding-block: 10px;\n    padding-inline: 20px;\n  }\n\n  &--grey {\n    background-color: $color-neutral-light;\n    color: $color-neutral-dark;\n  }\n\n  &--ongoing {\n    background-color: $clrWarning;\n    color: $clrWhite;\n\n    i {\n      animation: spin 0.3s infinite;\n    }\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.w-4 {\n  width: calc(100% / 3);\n}\n\n.w-3 {\n  width: calc(100% / 4);\n\n  &--wd {\n    width: calc(100% / 3);\n  }\n}\n\n.w-6 {\n  width: calc(100% / 2);\n}\n\n.fn {\n  &-row {\n    --rGap: 15px;\n    --rGap-minus: calc(-1 * var(--rGap));\n\n    display: flex;\n    flex-wrap: wrap;\n    margin-inline: var(--rGap-minus);\n\n    &--col-gap-exist {\n      .fn-col {\n        margin-bottom: calc($secPad / 2);\n      }\n    }\n  }\n\n  &-col {\n    padding-inline: var(--rGap);\n  }\n\n  &-justify-center {\n    justify-content: center;\n  }\n\n  &-items-center {\n    align-items: center;\n  }\n}\n\n.m {\n  &x-auto {\n    margin-inline: auto;\n  }\n\n  &l-auto {\n    margin-inline-start: auto;\n  }\n\n  &l-0 {\n    margin-inline-start: 0;\n  }\n\n  &r-auto {\n    margin-inline-end: auto;\n  }\n\n  &r-0 {\n    margin-inline-end: 0;\n  }\n}\n","@import './../../../../assets/styles/variables';\n\n\n::ng-deep.controller-wrapper {\n  &--profile {\n    .wrapper-content,\n    .ibox-content {\n\n      @media #{$mobile} {\n        padding-inline: 0;\n      }\n    }\n  }\n}\n\n.collab-body {\n  // display: flex;\n  // flex-wrap: wrap;\n  // align-items: center;\n  // min-height: 500px;\n\n  .collab-data {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    width: 100%;\n    padding-top: 80px;\n    padding-inline: 0;\n\n    @media #{$mobile} {\n      padding-top: 0 !important;\n      padding-inline: 0;\n    }\n\n    .collab-details {\n      padding: 34px 32px;\n      width: calc(100% / 3);\n\n\n      @media (max-width: 1200px) {\n        padding: 30px;\n      }\n\n      @media #{$tablet} {\n        width: 100%;\n        padding: 30px;\n\n        &+div {\n          margin-top: 17px;\n        }\n      }\n\n      @media #{$mobile} {\n        padding: 20px;\n      }\n\n      &__top {\n        display: flex;\n        flex-wrap: wrap;\n\n        &:not(:last-child) {\n          margin-bottom: 20px;\n        }\n\n        --size: 70px;\n\n        @media #{$pc} {\n          --size: 50px;\n        }\n\n        span,\n        h2 {\n          margin-top: 0;\n\n          &:last-child {\n            margin-bottom: 0;\n          }\n        }\n\n        span {\n          font-size: 10px;\n          list-height: 1.4;\n          color: #676a6c;\n          font-weight: 700;\n          display: block;\n\n          &:not(:last-child) {\n            margin-bottom: 5px;\n          }\n        }\n\n        h2 {\n          font-family: $muso-500;\n          font-size: clamp(18px, 1.95vw, 34px);\n\n          @media (max-width: 991px) {\n            font-size: 24px;\n          }\n        }\n\n        &--dark {\n\n          span,\n          h2 {\n            color: #fff;\n            font-weight: $fwBold;\n          }\n        }\n\n        &left {\n          width: calc(100% - var(--size));\n          padding-right: 10px;\n        }\n\n        &right {\n          width: var(--size);\n\n          &icon {\n            width: 100%;\n            height: var(--size);\n            padding: 10px;\n            background-color: #fff;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n\n            &--rounded {\n              border-radius: 50%;\n\n              &>* {\n                transform: scale(1.3);\n\n                @media #{$pc} {\n                  transform: none;\n                }\n              }\n            }\n          }\n\n          span {\n            transform: scale(1.5);\n            display: inline-block;\n          }\n        }\n      }\n\n      &__desc {\n        min-height: 160px;\n\n        *:last-child {\n          margin-bottom: 0;\n        }\n\n        p {\n          font-size: 14px;\n          line-height: 1.5;\n          font-family: $muso-500;\n        }\n\n        a {\n          text-decoration: underline;\n        }\n\n        &--dark {\n\n          p,\n          a {\n            color: #fff;\n          }\n\n          a:hover {\n            color: $develop-color;\n          }\n        }\n      }\n\n      &__social {\n        padding: 10px 0 0;\n        list-style: none;\n        margin: 0;\n        display: flex;\n        // flex-wrap: wrap;\n\n        li {\n          margin-right: 20px;\n          margin-bottom: 10px;\n          position: relative;\n\n          .tooltip-cpy::after {\n            content: \"Link Copied!\";\n            font-size: 9px;\n            margin-left: 7px;\n            color: #fff;\n            background-color: #73BF38;\n            padding: 3px 2px;\n            border-radius: 2px;\n            position: absolute;\n            z-index: 999;\n            left: 100%;\n            white-space: nowrap;\n            ;\n          }\n        }\n\n        img {\n          max-width: 26px;\n          max-height: 26px;\n          width: 100%;\n        }\n      }\n\n      &.bg-grey {\n        background-color: #F1F1F2;\n      }\n\n      .my-pf {\n        font-size: 10px;\n        line-height: 14px;\n        color: $body-content-color;\n        font-weight: $fwBold;\n      }\n\n      .social-icon {\n        padding: 10px 0 0;\n        list-style: none;\n        margin: 0;\n\n        li {\n          margin-left: 10px;\n          margin-bottom: 10px;\n\n          a {\n\n            img {\n\n              max-width: 26px;\n              max-height: 26px;\n              width: 100%;\n              margin-right: 10px;\n            }\n\n            svg {\n              vertical-align: middle;\n            }\n          }\n        }\n      }\n\n      &.icon-bg {\n        background-image: url($assets+\"/images/foursight-profile-types.svg\");\n      }\n\n      &.dark-bg {\n        background-color: #6D6E71;\n        position: relative;\n        visibility: hidden;\n\n        @media #{$tablet} {\n          min-height: 290px;\n          margin-top: 0 !important;\n        }\n\n\n        &::before {\n          content: \"\";\n          position: absolute;\n          height: 0;\n          width: 0;\n          left: -19px;\n          top: 80px;\n          width: 20px;\n          height: 40px;\n          background-color: $color-neutral-dark;\n          clip-path: polygon(0 50%, 100% 0, 100% 100%, 0 50%);\n\n          @media #{$tablet} {\n            width: 31px;\n            height: 15px;\n            top: auto;\n            bottom: calc(100% - 1px);\n            left: 50%;\n            transform: translateX(-50%);\n            clip-path: polygon(50% 0, 100% 100%, 0 100%);\n          }\n        }\n\n        &.visible {\n          visibility: visible;\n        }\n\n        .collab-benifits {\n          .collab-row {\n            ::ng-deep .collab-col {\n              width: 100%;\n\n              h2 {\n                color: #fff;\n                font-size: 10px;\n                line-height: 14px;\n                margin-bottom: 14px;\n                font-weight: $fwBold;\n                font-family: $font-stack;\n              }\n\n              select {\n                margin: 14px 0;\n                width: 289px;\n                min-height: 41px;\n                appearance: none;\n                background-repeat: no-repeat;\n                background-position: 96% 50%;\n                background-image: url(https://assets.foursightonline.com/admin-uploads/docs/267/original.png?1657190712);\n                background-size: 7%;\n                padding: 0 10px;\n              }\n\n              .collab-desc {\n\n                p {\n                  color: #fff;\n                  font-size: 14px;\n                  line-height: 18px;\n                  font-family: $muso-500;\n                }\n              }\n\n              &--pfwicn {\n\n                h2 {\n                  font-size: 28px;\n                  font-family: $muso-700;\n                  color: $body-content-color;\n                  margin: 0;\n                  color: #fff;\n                  line-height: 1;\n\n                  @media #{$mobile} {\n                    font-size: 22px;\n                  }\n                }\n\n                div>span {\n                  color: #fff;\n                  display: block;\n                  margin-bottom: 13px;\n                }\n\n                .collab-desc {\n                  width: 100%;\n                  padding: 19px 0;\n\n                  p {\n                    font-size: 14px;\n                    line-height: 1.3;\n                    font-family: $muso-500;\n                    color: $body-content-color;\n\n                    &:last-child {\n                      margin-bottom: 0;\n                    }\n                  }\n                }\n\n                &.pf-icon {\n                  width: 70px;\n                  height: 70px;\n                  background-color: #fff !important;\n                  // border-radius: 50%;\n                  display: flex;\n                  align-items: center;\n                  justify-content: center;\n\n                  .profile_types {\n                    transform: scale(1.5);\n                  }\n\n                  img {\n                    width: 100%;\n                    max-width: 52px;\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n\n      &.profile-icons {\n        padding: 35px 20px 35px 38px;\n        position: relative;\n\n\n        @media #{$tablet} {\n          border: 1px solid #E2E2E2;\n        }\n\n        @media #{$tablet} {\n          padding: 30px 24px;\n        }\n\n        &::before {\n          content: \"\";\n          position: absolute;\n          top: 0;\n          right: 0;\n          bottom: 0;\n          left: 18px;\n          border: 1px solid #E2E2E2;\n          pointer-events: none;\n\n          @media #{$tablet} {\n            display: none;\n          }\n        }\n\n        .collab-pf-img {\n          text-align: center;\n\n          p {\n            font-size: 16px;\n            line-height: 22px;\n            font-weight: $fwBold;\n          }\n        }\n\n        .pf-heading {\n\n          text-align: center;\n          margin-bottom: 15px;\n\n          p {\n            font-family: $font-stack;\n            font-weight: bold;\n            font-size: 16px;\n            margin: 0;\n          }\n\n          span {\n            font-size: 10px;\n            display: block;\n            line-height: 1.5;\n            margin-left: 10px;\n            color: $body-content-color;\n            font-style: italic;\n          }\n        }\n\n        .icons {\n\n          .icon-img {\n            list-style: none;\n            display: flex;\n            flex-wrap: wrap;\n            margin: 0 -2px;\n            padding: 0;\n\n            li {\n              width: 20%;\n              padding: 0 2px;\n              margin-top: 0px;\n\n              .icon-img__item {\n                text-align: center;\n                position: relative;\n                padding: 20px 2px 10px;\n                border: 1px solid transparent;\n                cursor: pointer;\n                box-shadow: 1px 2px 3px transparent;\n                height: 100%;\n                min-height: 80px;\n                opacity: 0.5;\n              }\n\n              @media #{$pc} {\n                width: calc(100% / 3);\n              }\n\n              span {\n                display: block;\n                height: 15px;\n                margin-top: 7px;\n              }\n\n              &.active {\n\n                .icon-img__item {\n                  opacity: 1;\n                  box-shadow: 1px 2px 3px #ccc;\n                }\n\n                &--focus {\n                  opacity: 1 !important;\n\n                  .icon-img__item {\n                    opacity: 1 !important;\n                    box-shadow: 1px 2px 3px #ccc;\n                  }\n                }\n              }\n\n              &.inactive {\n                opacity: 0.5;\n\n                &--focus {\n                  opacity: 0.5;\n\n                  &.active {\n                    opacity: 1;\n\n                    &--focues {\n                      opacity: 1;\n                    }\n                  }\n                }\n              }\n\n              svg,\n              img {\n                height: 21px;\n                max-width: 44px;\n                width: 100%;\n              }\n\n              span {\n                font-size: 8px;\n                display: block;\n              }\n            }\n          }\n        }\n      }\n    }\n\n    .collab-row {\n      display: flex;\n      flex-wrap: wrap;\n\n      &.flx-spcbtw {\n        justify-content: space-between;\n        align-items: center;\n      }\n\n      ::ng-deep.collab-col {\n\n        width: calc(100% - 70px);\n        padding-right: 10px;\n\n        h2 {\n          font-size: clamp(18px, 2.5vw, 34px);\n          font-family: $muso-700;\n          color: $body-content-color;\n          margin: 0;\n\n          @media #{$mobile} {\n            font-size: 24px;\n          }\n        }\n\n        .collab-desc {\n          width: 100%;\n          padding: 19px 0;\n          min-height: 160px;\n\n          p {\n            font-size: 14px;\n            line-height: 1.3;\n            font-family: $muso-500;\n            color: $body-content-color;\n\n            &:last-child {\n              margin-bottom: 0;\n            }\n\n            a {\n              cursor: pointer;\n              text-decoration: underline;\n\n              &:not(.p_link) {\n                color: #fff;\n              }\n            }\n          }\n        }\n\n        &.pf-icon {\n          width: 70px;\n          height: 70px;\n          background-color: #fff !important;\n          border-radius: 50%;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          flex: none;\n          padding: 10px;\n          ;\n\n          .profile_types {\n            transform: scale(1.5);\n          }\n        }\n      }\n    }\n  }\n}\n\n.tp {\n  &__dd {\n    position: relative;\n\n    &:hover>.tp__ddbody {\n      display: block;\n    }\n  }\n\n  &__ddhdr {\n    display: flex;\n    flex-wrap: wrap;\n    cursor: pointer;\n    color: $body-content-color;\n    padding: 12px 19px;\n    background-color: #fff;\n    background-image: url(https://assets.foursightonline.com/admin-uploads/docs/267/original.png?1657190712);\n    background-size: 13px 8px;\n    background-repeat: no-repeat;\n    background-position: right 15px center;\n  }\n\n  &__ddhdrtext,\n  &__ddbodytext {\n    font-size: 14px;\n    line-height: 19px;\n  }\n\n  &__ddhdrimage,\n  &__ddbodyimage {\n    width: 19px;\n    margin-left: 9px;\n\n    svg {\n      width: 100%;\n      height: auto;\n    }\n  }\n\n  &__ddbody {\n    background-color: #fff;\n    position: absolute;\n    top: 100%;\n    left: 0;\n    width: 100%;\n    z-index: 9;\n    max-height: 176px;\n    overflow-y: auto;\n    border-top: 1px solid $color-neutral-dark;\n    display: none;\n\n    ul {\n      padding: 0;\n      margin: 0;\n    }\n\n    li {\n      display: flex;\n      flex-wrap: wrap;\n      cursor: pointer;\n      color: $body-content-color;\n      padding: 12px 19px;\n\n      &.active {\n        background-color: $color-neutral-light;\n      }\n    }\n  }\n}\n\n@media print {\n  .collab-body {\n    .collab-data {\n      padding-inline: 0;\n      margin-inline: -15px;\n\n      .collab-details {\n        padding: 15px;\n\n        .social-icon {\n          li {\n            width: 13%;\n\n            img {\n              height: 20px !important;\n              width: auto !important;\n            }\n\n            svg {\n              transform: scale(0.7)\n            }\n          }\n        }\n\n        &.profile-icons {\n          padding: 15px;\n\n          &::before {\n            display: none;\n          }\n\n          .icons {\n            .icon-img {\n              margin-inline: -10px;\n\n              li {\n                min-height: initial;\n\n                img {\n                  height: auto;\n                }\n              }\n            }\n          }\n        }\n\n        &.bg-grey {\n          background-color: #F1F1F2 !important;\n        }\n\n        &.dark-bg {\n          background-color: #6D6E71 !important;\n\n          .collab-col--pfwicn {\n            .pfw-icon {\n              .flx-spcbtw {\n                h2 {\n                  color: #fff !important;\n                }\n\n                span {\n                  color: #fff !important;\n                  margin-bottom: 0;\n                }\n              }\n            }\n          }\n\n          .collab-desc {\n\n            p {\n              color: #fff !important;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n.loader-container {\n  position: absolute;\n  left: 0;\n  right: 0;\n  text-align: center;\n  top: 0;\n  bottom: 0;\n  background: rgba(236, 236, 236, .9);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  z-index: 9999999999;\n  height: 100vh;\n  margin: 0 auto;\n}\n\n.loader-spin {\n  background-color: hsla(0, 0%, 92.5%, .9);\n  position: fixed;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  right: 0;\n}\n\n.loader__inner {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n\n}\n\n#Path_129 {\n  animation: blink 2s linear infinite;\n  opacity: 0;\n}\n\n#Path_130 {\n  animation: blink 2s linear infinite;\n  animation-delay: .5s;\n  opacity: 0;\n}\n\n#Path_132 {\n  animation: blink 2s linear infinite;\n  animation-delay: 1s;\n  opacity: 0;\n}\n\n#Path_131 {\n  animation: blink 2s linear infinite;\n  animation-delay: 1.5s;\n  opacity: 0;\n}\n\n@keyframes blink {\n  0% {\n    opacity: 0;\n  }\n\n  50% {\n    opacity: 1;\n  }\n\n  100% {\n    opacity: 0;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
